import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CustomerTypes } from "../enums/CustomerType";
import { BRANDS_CATEGORY_ID } from "./BRANDS_CATEGORY_ID";
import { RETAILERS_CATEGORY_ID } from "./RETAILERS_CATEGORY_ID";
export var CATEGORY_ID = _defineProperty(_defineProperty(_defineProperty({}, CustomerTypes.RETAILER, RETAILERS_CATEGORY_ID), CustomerTypes.BRAND, BRANDS_CATEGORY_ID), CustomerTypes.UNKNOWN, 0);